import { FlexRow } from 'components'
import { DesktopMode, MobileMode } from 'layout'
import { Button } from 'semantic-ui-react'
import styled from 'styled-components'

export const AppButton = ({ loading, ...rest }) => (<>
  <DesktopMode>
    <Button {...rest} loading={Boolean(loading)} />
  </DesktopMode>
  <MobileMode>
    <Button {...rest} size="tiny" loading={Boolean(loading)} />
  </MobileMode>
</>)

export const AppPrimaryButton = styled(AppButton)`
  background: ${({ theme }) => theme.colors.primary} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  `
export const AppDangerButton = styled(AppButton)`
  background: ${({ theme }) => theme.colors.danger} !important;
  color: ${({ theme }) => theme.colors.white} !important;
  `

export const AppSecondaryButton = styled(AppButton)`
    height: 100%;
  `

export const LinkText = styled.div`
  color: ${({ theme }) => theme.colors.black} !important;
  text-decoration: ${({ noUnderline }) => noUnderline ? "none" : "underline"};
  cursor: pointer;
  position: relative;
  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary} !important;
  }
  `;

export const SubmitCancelButtons = ({ loading, onSubmit, onCancel, className, hideCancel = false, cancelText = "Cancel", submitText = "Submit" }) => {
  return (
    <>
      <DesktopMode>
        <FlexRow className={`justify-content-end ${className}`}>
          <AppPrimaryButton loading={loading} onClick={onSubmit}>
            {submitText}
          </AppPrimaryButton>
          {!hideCancel && <AppButton type="button" onClick={onCancel}>
            {cancelText}
          </AppButton>}
        </FlexRow>
      </DesktopMode>
      <MobileMode>
        <FlexRow className={`${className} justify-content-end`}>
          <AppPrimaryButton loading={loading} className="col  col-sm-2 col-md-2" onClick={onSubmit}>
            {submitText}
          </AppPrimaryButton>
          {!hideCancel && <AppButton type="button" className="col col-sm-2  col-md-2" onClick={onCancel}>
            {cancelText}
          </AppButton>}
        </FlexRow>
      </MobileMode>
    </>
  )
}